var map = {
	"./Avatar.png": "76e3",
	"./Gdown.png": "5702",
	"./add.png": "9b8d",
	"./add.svg": "3592",
	"./android.png": "6f64",
	"./bankFile.png": "6f04",
	"./card.png": "64d0",
	"./check.png": "2aeb",
	"./down.png": "b265",
	"./ele-sign.svg": "784b",
	"./email.png": "aef1",
	"./email.svg": "eb49",
	"./error.png": "bb31",
	"./gift.png": "5e73",
	"./goldEmail.png": "e2fd",
	"./gray-down.png": "6039",
	"./hideEye.png": "67c0",
	"./home.png": "9bf29",
	"./icons_Marketing_resources.svg": "0e53",
	"./icons_coins.svg": "93a2",
	"./icons_flex.svg": "fcdc",
	"./icons_increase.svg": "db9a",
	"./icons_online_card.svg": "edd6",
	"./icons_user_support.svg": "a42c",
	"./identify.png": "06eb",
	"./ios.png": "8d83",
	"./menu_blue.png": "5214",
	"./menu_white.png": "69c1",
	"./passport.png": "a3ba",
	"./photo.png": "591d",
	"./question.png": "21c9",
	"./right.png": "2254",
	"./right_click.png": "1d7a",
	"./save.png": "c7d8",
	"./search-icon.svg": "1ae5",
	"./search.png": "8f8b",
	"./setting.png": "b43e",
	"./showEye.png": "c351",
	"./switch.png": "eb4b",
	"./tick.png": "ac58",
	"./transfer.png": "00bd",
	"./vertify.png": "8d6a",
	"./waterFile.png": "0220",
	"./white-right.png": "c83a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";